module.exports = __webpack_public_path__ + "img/belgium-genitourinary-diseases-female.b28d572d.png";